import { appStatuses } from '@developer/portal/config';

export function getAppStatusIconByStatus(status: any) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return appStatuses?.[status]?.img;
}
